module.exports = __webpack_public_path__ + "img/icon-caret-down.f912f3c6.svg";